<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Ej0VJ/tc-custom/9781630477387.jpg?1700958170243" alt="This image is the cover for the book Shift the Narrative"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Shift the Narrative
      </h1>
      <p class="bookDescription body article font2">
        <i>Shift</i> is a blind man’s vision of how he changed his life narrative from the impossible to the economically probable and in the process, moved from welfare to wealth. Blind from the age of 16, Russell Redenbaugh's achievement as a successful investor and economist, a Commissioner on the US Civil Rights Commission serving under three US Presidents and a black belt, three time gold medal jiu-jitsu world champion fighting sighted opponents, prove that if he can, anyone can. Most people think that their circumstances produce their narratives, but Russell shows it is their narratives that produce their circumstances. If you change your story, you change your future. Through a set of actions and behaviors, Russell demonstrates how anyone can "Shift Your Narrative" to produce more of what they care about in their personal life, career and money matters, starting today.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Russell Redenbaugh, George Gilder
      </h2>
      
      <p class="authorDescription body article">Blind from the age of 16, Russell Redenbaugh's achievements as a successful investor and economist, a Commissioner on the US Civil Rights Commission serving under three US Presidents and a black belt, three time gold medal jiu-jitsu world champion fighting sighted opponents, prove that if he can, you can. With the first MBA awarded to a blind student from the University of Pennsylvania's Wharton Business School, Russell went on to become Chief Investment Officer at a prominent Philadelphia money management firm that he helped grow to $6 billion in assets. After successfully selling the firm as one of six partners, Russell moved on to teach at Wharton, serve as a Commissioner on the US Civil Rights Commission and consult global corporations such as IBM, Applied Materials and KLA Tencor on "Shifting the Narrative" through process/metric design. Russell founded and is managing partner of Kairos Capital Advisors, a Registered Investment Advisor, where he manages his own and his clients' money using strategies departing from flawed investment industry narratives.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Morgan James Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3d7b29c3